import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=b6df25fe&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=ts"
export * from "./AddDepartment.vue?vue&type=script&lang=ts"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=b6df25fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6df25fe",
  null
  
)

export default component.exports